// api/product.js
import request from '@/utils/request'

/**
 * 获取产品列表（支持分页、分类、标签、关键词搜索）
 * @param {Object} params 查询参数
 * @param {string} params.category 产品分类代码
 * @param {string} params.tag 标签（hot/new/recommend）
 * @param {string} params.keyword 搜索关键词
 * @param {number} params.page 页码，默认1
 * @param {number} params.pageSize 每页数量，默认10
 * @returns {Promise} 产品列表
 */
export const getProducts = (params) => {
  return request({
    url: '/api/products',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取产品详情
 * @param {string|number} id 产品ID
 * @returns {Promise} 产品详情数据
 */
export const getProductById = (id) => {
  return request({
    url: `/api/products/${id}`,
    method: 'get'
  })
}


export function getProductsByCategory(categoryCode, page = 1, pageSize = 5) {
  return request({
    url: '/api/products',
    method: 'get',
    params: {
      categoryCode,
      page,
      pageSize
    }
  })
}


/**
 * 获取相关产品推荐
 * @param {Object} params 查询参数
 * @param {number} params.categoryId 分类ID
 * @param {number} params.excludeId 排除的产品ID
 * @param {number} params.limit 返回数量限制，默认4
 * @returns {Promise} 相关产品列表
 */
export const getRelatedProducts = (params) => {
  return request({
    url: '/api/products/related',
    method: 'get',
    params
  })
}

/**
 * 获取所有产品分类
 * @returns {Promise} 分类列表
 */
export const getCategories = () => {
  return request({
    url: '/api/categories',
    method: 'get'
  })
}

/**
 * 获取产品矩阵：后端聚合好的"分类树 + 每个大类下的首屏产品 + 总数"。
 * 前端一次请求即可渲染整个产品页，无需自行建树或按大类循环请求。
 * @param {number} pageSize 每个大类返回的首屏产品数量，默认6
 * @returns {Promise} 分类矩阵列表
 */
export const getProductMatrix = (pageSize = 6) => {
  return request({
    url: '/api/products/matrix',
    method: 'get',
    params: { pageSize }
  })
}